export enum GiantButtonType {
  OUTLINED = 'OUTLINED',
  OUTLINED_COLOR = 'OUTLINED_COLOR',
  SOLID = 'SOLID'
}

export enum GiantButtonSize {
  DEFAULT = 'DEFAULT',
  LARGE = 'LARGE'
}
